interface LegalSection {
  title: string;
  paragraphs: string[];
}

interface LegalPageProps {
  title: string;
  subtitle: string;
  updatedAt: string;
  sections: LegalSection[];
}

export default function LegalPage({ title, subtitle, updatedAt, sections }: LegalPageProps) {
  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="px-4 md:px-8 lg:px-16 xl:px-24 py-16 md:py-24">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-pink-50 text-pink-600 text-sm font-medium mb-4">
            法律声明
          </span>
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-3">{title}</h1>
          <p className="text-gray-500 text-base md:text-lg mb-4">{subtitle}</p>
          <p className="text-xs text-gray-400 mb-12">更新日期：{updatedAt}</p>

          <div className="space-y-12">
            {sections.map((section, si) => (
              <section key={section.title}>
                <h2 className="flex items-start gap-3 font-serif text-xl md:text-2xl font-bold text-gray-900 mb-5">
                  <span className="font-serif text-sm text-pink-400 pt-1.5 shrink-0">
                    {String(si + 1).padStart(2, '0')}
                  </span>
                  {section.title}
                </h2>
                <div className="pl-8">
                  {section.paragraphs.map((p, i) => (
                    <p key={i} className="text-gray-600 text-sm md:text-base leading-loose mb-4">
                      {p}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}